<app-header></app-header>
<div class="container px-5 min-h-100vh align-content-center">
    <div class="row m-0 align-content-center mt-4">
        <h1 class="ff-bold text-center">
            Anexo 24 Rubro C
        </h1>
    </div>
    <!--<div class="row m-0 radio-block">
        <div class="col-12 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100" for="Puebla">
                <a class="text-nowrap text-black ff-bold text-decoration-none">
                    Puebla
                </a>
                <input type="radio" name="category" value="Puebla" id="Puebla" (change)="chooseCategory($event)">
            </label>
        </div>
        <<div class="col-12 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100" for="Nogales">
                <a class="text-nowrap text-black ff-bold text-decoration-none">
                    Nogales
                </a>
                <input type="radio" name="category" value="Nogales" id="Nogales" (change)="chooseCategory($event)">
            </label>
        </div>
        <div class="col-12 col-md-4 p-1">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100" for="Reynosa">
                <a class="text-nowrap text-black ff-bold text-decoration-none">
                    Reynosa
                </a>
                <input type="radio" name="category" value="Reynosa" id="Reynosa" (change)="chooseCategory($event)">
            </label>
        </div>
    </div>-->

    <div *ngIf="category && category.length>0" class="row m-0 category-block mt-4">
        <div class="col-12 col-sm-6 col-md-4 p-1" routerLink="/category/1" (click)="fetchCategory('Catálogos')">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" for="Catálogos">
                <a class="text-nowrap text-black ff-bold text-decoration-none py-3 py-md-5">
                    Catálogos
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1" routerLink="/category/2" (click)="fetchCategory('Módulo de Aduana')">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" for="Módulo de Aduana">
                <a class="text-nowrap text-black ff-bold text-decoration-none py-3 py-md-5">
                    Módulo de Aduana
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
        <div class="col-12 col-sm-6 col-md-4 p-1" routerLink="/category/3" (click)="fetchCategory('Módulo de reports')">
            <label class="pointer w-100 d-flex justify-content-between p-3 align-items-center h-100 py-3 py-md-5" for="Módulo de reports">
                <a class="text-nowrap text-black ff-bold text-decoration-none py-3 py-md-5">
                    Módulo de reports
                </a>
                <img src="./assets/images/vector-right.svg" style="height: 15px;" alt="">
            </label>
        </div>
    </div>
</div>

<app-footer></app-footer>